import { Box, Grid, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import Apple from '../../img/AppStore.svg'
import Banner from '../../img/banner-couple.webp'
import Google from '../../img/Google.svg'
import Footer from '../Shared/Footer'
import SiteHeader from '../Shared/SiteHeader'

const Navbar = () => {
  return (
    <div className='page-shell'>
      <SiteHeader />
      <Box className='page-content'>
        <Box className='page-container'>
          <Grid container alignItems='center' spacing={{ xs: 4, md: 6 }}>
            <Grid item xs={12} md={6}>
              <Box className='hero-content'>
                <Typography
                  component='h1'
                  sx={{
                    fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem', lg: '4rem' },
                    fontWeight: 800,
                    lineHeight: 1.1,
                    letterSpacing: '-0.03em',
                    mb: 2,
                  }}
                >
                  The <span className='color-accent'>3Knots</span> App
                </Typography>
                <Typography
                  sx={{
                    color: 'rgba(255,255,255,0.72)',
                    fontSize: { xs: '1rem', md: '1.15rem' },
                    lineHeight: 1.7,
                    maxWidth: 480,
                  }}
                >
                  Marriage Matrimony – Find Your Perfect Life Partner with Smart Marriage Matching
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    mt: 4,
                    justifyContent: { xs: 'center', md: 'flex-start' },
                  }}
                >
                  <Link
                    to='https://play.google.com/store/apps/details?id=com.threeknots.app'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='store-badge'
                  >
                    <Box component='img' src={Google} alt='Get it on Google Play' sx={{ height: 52 }} />
                  </Link>
                  <Link
                    to='https://apps.apple.com/us/app/3knots/id6742329827'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='store-badge'
                  >
                    <Box component='img' src={Apple} alt='Download on the App Store' sx={{ height: 52 }} />
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box className='hero-image-wrap'>
                <Box className='hero-glow' aria-hidden />
                <Box
                  component='img'
                  src={Banner}
                  alt='Newlywed couple in traditional South Indian wedding attire'
                  className='hero-image'
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Footer />
    </div>
  )
}

export default Navbar
